import { getOS } from '@iconik-io/core/src/os/get_os';

const SUFFIX_STRING = '__suffix:';

export const hasSuffix = (value = '') => value.includes(SUFFIX_STRING);

export const getSuffix = (value = '') => {
  if (!value || !hasSuffix(value)) {
    return '';
  }
  return value.substring(value.indexOf(SUFFIX_STRING) + SUFFIX_STRING.length);
};

export const removeSuffix = (value = '') => {
  if (!value || !hasSuffix(value)) {
    return value;
  }
  return value.substring(0, value.indexOf(SUFFIX_STRING));
};

export function isHoldingOnlyCtrlKey(event: KeyboardEvent) {
  const isHoldingShiftAltKey = event.shiftKey || event.altKey;
  return (
    (event.metaKey &&
      getOS() === 'MacOS' &&
      !event.ctrlKey &&
      !isHoldingShiftAltKey) ||
    (event.ctrlKey &&
      getOS() !== 'MacOS' &&
      !event.metaKey &&
      !isHoldingShiftAltKey)
  );
}
